module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sp"
  }), _vm._v(" "), _c('p', {
    staticClass: "EP"
  }, [_vm._v("The biggest threat to world peace? Young men between the ages of eighteen and twenty-five, especially if they are unemployed, unmarried and don’t own property.")]), _vm._v(" "), _c('p', {
    staticClass: "EPC1"
  }, [_c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("DR CLAYBORNE CARSON")])]), _vm._v(" "), _c('p', {
    staticClass: "EP"
  }, [_vm._v("He may be a son-of-a-bitch but he’s our son-of-a-bitch.")]), _vm._v(" "), _c('p', {
    staticClass: "EPC"
  }, [_c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("FRANKLIN D. ROOSEVELT")])]), _vm._v(" "), _c('p', {
    staticClass: "EPC"
  }, [_vm._v("on President Somoza of Nicaragua")]), _vm._v(" "), _c('p', {
    staticClass: "EPC1"
  }, [_vm._v("(attribution disputed)")]), _vm._v(" "), _c('p', {
    staticClass: "EP"
  }, [_vm._v("Working in the fields, we wore out our hats quickly.")]), _vm._v(" "), _c('p', {
    staticClass: "EPC"
  }, [_c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("PRAMOEDYA ANANTA TOER")]), _vm._v(",")]), _vm._v(" "), _c('p', {
    staticClass: "EPC"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("The Mute’s Soliloquy")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-003c06b1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/epigraphs.vue
// module id = 72
// module chunks = 0